<template>
	<section class="newsletter">
		<div class="row">
			<div class="columns column6">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column6">
				<div id="mc_embed_shell">
					<div id="mc_embed_signup">
						<form
							id="mc-embedded-subscribe-form"
							action="https://alerdinck.us16.list-manage.com/subscribe/post?u=899b738dfd3a49acbb13f685d&id=18c8a68645&f_id=00d0c2e1f0"
							method="post"
							name="mc-embedded-subscribe-form"
							class="validate newsletter"
							target="self"
							novalidate=""
						>
							<div id="mc_embed_signup_scroll" class="mc-embed">
								<div class="mc-field-group">
									<input
										id="mce-EMAIL"
										type="email"
										name="EMAIL"
										class="required email"
										required=""
										:placeholder="$t('formEmail')"
										value=""
									/>
									<input
										id="mc-embedded-subscribe"
										type="submit"
										name="subscribe"
										class="button"
										:value="button"
									/>
								</div>
								<div id="mce-responses" class="clear foot">
									<div id="mce-error-response" class="response" style="display: none"></div>
									<div id="mce-success-response" class="response" style="display: none"></div>
								</div>
								<div aria-hidden="true" style="position: absolute; left: -5000px">
									<input
										type="text"
										name="b_899b738dfd3a49acbb13f685d_18c8a68645"
										tabindex="-1"
										value=""
									/>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	background: var(--primary-background-color);

	.mc-embed {
		width: 100%;
	}

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		border: none;
		padding: 0 20px;
		line-height: 40px;
		outline: none !important;
		background: none;
		color: #000;
		font-size: var(--body-font-size);
		width: 100%;
	}

	.mc-field-group {
		width: 100%;
		display: flex;
		flex-flow: row wrap;

		input {
			width: 50%;
		}
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
		font-size: calc(var(--body-font-size) - 3px);
		width: 36%;
	}

	.row {
		max-width: 100%;
		width: 100%;
		position: relative;
		overflow: hidden;

		.column6 {
			width: 54%;
			padding: 100px 80px;
			text-align: left;
			z-index: 1;
			background: #fff;

			&:last-child {
				width: 50%;
				position: relative;
				z-index: 2;
				background: var(--cta-color);
				margin: 100px 0 0;
				float: right;
			}

			&:first-child {
				position: absolute;
				inset: 0 auto 100px 0;
				padding-right: 120px;
			}
		}
	}
}

form.newsletter {
	background: var(--primary-background-color);
	padding: 15px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	margin: 20px auto 50px;
	box-shadow: 0 24px 24px rgb(0 0 0 / 15%);
	width: 100%;
	max-width: 700px;
}

::placeholder {
	color: #000;
}

@media (max-width: 1280px) {
	.newsletter {
		.row {
			max-width: 800px;

			.column6 {
				width: 92%;
				position: relative;
				inset: auto;
				padding: 40px 60px;

				&:first-child {
					margin: 0 8% 0 0;
					position: relative;
					inset: auto;
				}

				&:last-child {
					width: 92%;
					margin: 0 0 0 8%;
					position: relative;
					inset: auto;
				}
			}
		}
	}
}

@media (max-width: 680px) {
	.newsletter {
		text-align: center;

		.row {
			max-width: 94%;

			.column6 {
				width: 100%;

				&:first-child {
					margin: 0;
					padding: 40px 25px;
				}

				&:last-child {
					width: 100%;
					margin: 0;
					padding: 30px 25px;
				}
			}
		}
	}

	form.newsletter {
		margin: 0;
		flex-flow: column wrap;
		text-align: center;
		padding: 15px 30px;

		input:not(.button) {
			border: none;
			padding: 10px 20px;
			width: 100%;
			text-align: center;
			font-size: 14px;

			&:first-child {
				border-right: none;
				border-bottom: 1px solid var(--subtitle-color);
			}
		}

		.button {
			width: 100%;
			font-size: 12px;
		}
	}
}
</style>
